import { removeTempPatientId } from "../../utils/openPatientTab";

// middleware/patientStorageMiddleware.js
export const patientStorageMiddleware = (store) => (next) => (action) => {
  const result = next(action);

  if (action.type === "selectedPatient/updateSelectedPatient") {
    const patientData = action.payload;
    if (patientData) {
      sessionStorage.setItem("patientId", patientData.patientId);
    } else {
      sessionStorage.removeItem("patientId"); // Optional: cleanup
    }

    removeTempPatientId();
  }

  return result;
};
